export enum CardType {
	Meal = 'meal',
	WiFi = 'wifi',
	Aircraft = 'aircraft',
	Seats = 'seats',
	City = 'city'
}

export interface Card {
	city?: string;
	type: CardType;
	title?: string;
	text?: string;
	image: string;
}
